<template>
  <div class="negative">
    <section v-if="isStatusDetailCodeRecurrencyNotSupported">
      <h2 class="normal" v-html="$t('result.negative.recurrencyNotSupported.header')"></h2>
      <p v-html="$t('result.negative.recurrencyNotSupported.description1')"></p>
      <p v-html="$t('result.negative.recurrencyNotSupported.description2')"></p>
      <div class="result-buttons">
        <partner-return-btn v-if="visibilityOptions && visibilityOptions.showReturnToShopButton && continueUrl"
                            :show-timer="false"
                            :return-url="continueUrl"
                            :return-text="$t('result.negative.recurrencyNotSupported.buttonContinue')"/>
        <a v-if="visibilityOptions && visibilityOptions.showReturnToShopButton" class="btn btn-link" style="margin-top: 20px" :href="returnUrl">
          {{ $t('result.negative.recurrencyNotSupported.buttonReturn') }}
        </a>
      </div>
    </section>
    <section v-if="isStatusDetailCodeWrongTicket">
      <h2 class="normal" v-html="$t('result.negative.wrongTicket.header')"></h2>
      <p v-html="$t('result.negative.wrongTicket.description')"></p>
      <div class="result-buttons">
        <partner-return-btn v-if="visibilityOptions && visibilityOptions.showReturnToShopButton && continueUrl"
                            :show-timer="false"
                            :return-url="continueUrl"
                            :return-text="$t('result.negative.wrongTicket.buttonContinue')"/>
        <a v-if="visibilityOptions && visibilityOptions.showReturnToShopButton" class="btn btn-link" style="margin-top: 20px" :href="returnUrl">
          {{ $t('result.negative.wrongTicket.buttonReturn') }}
        </a>
      </div>
    </section>
    <section v-if="isStatusDetailCodeGeneric">
      <h2 class="normal" v-html="$t('result.negative.generic.header')"></h2>
      <p v-html="$t('result.negative.generic.description')"></p>
      <div class="result-buttons">
        <partner-return-btn v-if="visibilityOptions && visibilityOptions.showReturnToShopButton && continueUrl"
                            :show-timer="false"
                            :return-url="continueUrl"
                            :return-text="$t('result.negative.generic.buttonContinue')"/>
        <a v-if="visibilityOptions && visibilityOptions.showReturnToShopButton" class="btn btn-link" style="margin-top: 20px" :href="returnUrl">
          {{ $t('result.negative.generic.buttonReturn') }}
        </a>
      </div>
    </section>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { BLIK_ERROR } from '@/base/const/blik.const'
import PartnerReturnBtn from '@/base/components/Confirmation/PartnerReturnBtn.vue'

export default {
  name: 'ResultNegative',
  components: { PartnerReturnBtn },
  computed: {
    ...mapState({
      statusDetailCode: state => state.result.data ? state.result.data.statusDetailCode : null,
      transaction: state => state.result.data?.transaction,
      visibilityOptions: state => state.result.data?.visibilityOptions,
      continueUrl: state => state.result.data?.continueUrl,
      returnUrl: state => state.result.data?.returnUrl
    }),
    isStatusDetailCodeRecurrencyNotSupported: function () {
      return this.statusDetailCode && this.statusDetailCode === BLIK_ERROR.recurrencyNotSupported
    },
    isStatusDetailCodeWrongTicket: function () {
      return this.statusDetailCode && this.statusDetailCode === BLIK_ERROR.wrongTicket
    },
    isStatusDetailCodeGeneric: function () {
      return !this.isStatusDetailCodeRecurrencyNotSupported && !this.isStatusDetailCodeWrongTicket
    }
  }
}
</script>
